module.exports = __webpack_public_path__ + "static/media/football.2860cc86.webp";